import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding-top: 20px;
  width: 100%;
  justify-content: space-between;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
`
